module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4wcXEBw1jwhKtAAAAAl0RVh0Q29tbWVudAAKaf9kGAAAAA5JREFUGNNjYBgFgxMAAAGaAAELop0fAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blank.png
// module id = u+0x
// module chunks = 44